<template>
  <!-- 国家及地区英文 -->
  <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
    <a-row>
      <a-col :span="24" class="tar">
        <a-button type="primary" @click="show" size="small">创建系统</a-button>
      </a-col>
    </a-row>
  </a-form>
  <EventAlert v-if="visible" />
</template>
<script>
import { inject, toRefs } from 'vue'
import EventAlert from './EventAlert.vue'
export default {
  components: {
    EventAlert
  },
  setup() {
    const state = inject('systemState')
    return {
      labelCol: { span: 10 },
      wrapperCol: { span: 14 },

      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.search-box {
  :deep .portal-ant-card-body {
    padding: 0;
  }
}
</style>
